<i18n
  src="@/locales/views/agro_exporter/quality_control/crop_field/crop_field_inspect_graphs.yml"
  lang="yaml"
></i18n>
<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    name="ae_quality_control_crop_field_list_crop_fields_path"
    :params="{
      agro_exporter_id: agro_exporter_id,
      producer_id: producer_id,
    }"
  ></go-back-link>
  <bread-crumbs
    :labels="[
      module_name,
      producer?.name,
      quality_template?.name,
    ]"
  ></bread-crumbs>
  <div v-if="crop_fields.length > 0">
    <div class="page-title">Porcentaje de calidad</div>
    <percent-graph
      v-if="crop_fields"
      :crop_fields="crop_fields"
      :quality_attributes="quality_attributes"
    />
    <!-- <div
      v-for="quality_attribute in quality_attributes"
      :key="quality_attribute.id"
    >
      <div class="page-title mt-8">
        {{ quality_attribute.crop_attribute.name }}
      </div>
      <attribute-graph
        :crop_fields="crop_fields"
        :quality_attribute="quality_attribute"
      />
    </div> -->
  </div>
  <div class="panel p-2" v-else>
    <p>No hay registros de este tipo de inspecciones</p>
  </div>
  <div></div>
</template>

<script>
import Requester from "@/views/agro_exporter/requesters/quality_control/crop_field/crop_field_inspect_graphs.js";
import PercentGraph from "@/components/views/agro_exporter/quality_control/crop_field/crop_field_inspect_graphs/PercentGraph.vue";
// import AttributeGraph from "@/components/views/agro_exporter/quality_control/crop_field/crop_fields_inspect_graphs/AttributeGraph.vue";

import BreadCrumbs from "@/components/views/layout/BreadCrumbs.vue";
export default {
  components: { BreadCrumbs, PercentGraph },
  props: {
    agro_exporter_id: { required: true },
    producer_id: {
      required: true,
    },
    producer_quality_template_id: {
      required: true,
    },
  },
  data: function () {
    return {
      producer: null,
      quality_template: null,
      crop_fields: [],
      quality_attributes: null,
    };
  },
  methods: {
    fetchProducer: async function () {
      let response = await Requester.fetchProducer(
        this.agro_exporter_id
      );
      this.producer = response.data;
    },
    fetchProducerQualityTemplate: async function () {
      let response = await Requester.fetchExporterQualityTemplate(
        this.agro_exporter_id,
        this.producer_quality_template_id
      );
      this.quality_template = response.data;
    },
    fetchCropFields: async function () {
      let response = await Requester.fetchCropFields(
        this.agro_exporter_id,
        this.producer_quality_template_id
      );
      this.crop_fields = response.data.crop_fields;
      this.quality_attributes =
        response.data.quality_attributes;
    },
  },
  created: function () {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          agro_exporter_id: this.agro_exporter_id,
        },
      }).then(() => {
        this.fetchProducer();
        this.fetchProducerQualityTemplate();
        this.fetchCropFields();
      })
    );
  },
};
</script>

<style>
</style>
